const riddles = {
  'أ': [
    { 
      riddle: 'أنا مخلوق صغير رشيق، أرقص بين الأعشاب بقفزاتي السريعة، أذناي طويلتان وذيلي كقطعة قطن، من أكون؟ (حرف أ)', 
      answer: 'أرنب',
      hint: 'لوني غالبًا أبيض أو بني'
    },
    { 
      riddle: 'أنا فاكهة استوائية ذهبية، قشرتي شائكة وقلبي حلو المذاق، أبدأ بحرف أ، من أكون؟', 
      answer: 'أناناس',
      hint: 'أشبه التاج على رأسي'
    },
    { 
      riddle: 'أنا أداة صغيرة نحيلة، أساعد في خياطة الملابس، أبدأ بحرف أ، من أكون؟', 
      answer: 'إبرة',
      hint: 'لدي عين صغيرة في رأسي'
    },
    { 
      riddle: 'أنا مكان فني جميل، يأتي الناس لمشاهدة العروض والمسرحيات، أبدأ بحرف أ، من أكون؟', 
      answer: 'أوبرا',
      hint: 'مكان للغناء والموسيقى'
    },
    { 
      riddle: 'أنا نبات صغير أخضر، أزرع في حقول المياه، أكون طعامًا شهيًا، من أكون؟', 
      answer: 'أرز',
      hint: 'أنا من أهم الأطعمة في العالم'
    }
  ],
  'ب': [
    { 
      riddle: 'أنا حيوان كبير قوي، أعطي الحليب الطازج، أبدأ بحرف ب، من أكون؟', 
      answer: 'بقرة',
      hint: 'لوني أبيض وأسود'
    },
    { 
      riddle: 'أنا فاكهة صيفية كبيرة، قشرتي خضراء وقلبي أحمر حلو، أبدأ بحرف ب، من أكون؟', 
      answer: 'بطيخ',
      hint: 'أنا مليء بالبذور السوداء'
    },
    { 
      riddle: 'أنا شيء مهم في كل بيت، أفتح وأغلق، أبدأ بحرف ب، من أكون؟', 
      answer: 'باب',
      hint: 'أحتاج إلى مفتاح لأفتح'
    },
    { 
      riddle: 'أنا مكان جميل مليء بالأشجار والزهور، أبدأ بحرف ب، من أكون؟', 
      answer: 'بستان',
      hint: 'مكان للتنزه واللعب'
    },
    { 
      riddle: 'أنا نبات ذو رائحة قوية، أستخدم في الطبخ، أبدأ بحرف ب، من أكون؟', 
      answer: 'بصل',
      hint: 'أجعل عيونك تدمع عندما تقطعني'
    }
  ],
  'ت': [
    { 
      riddle: 'أنا حيوان مائي كبير، أسبح في النهر، أبدأ بحرف ت، من أكون؟', 
      answer: 'تمساح',
      hint: 'لدي فك قوي وأسنان حادة'
    },
    { 
      riddle: 'أنا فاكهة حمراء أو خضراء، أكون طازجة وعصيرية، أبدأ بحرف ت، من أكون؟', 
      answer: 'تفاح',
      hint: 'أنا فاكهة مشهورة جدًا'
    },
    { 
      riddle: 'أنا جهاز في كل بيت، أريكم الصور المتحركة، أبدأ بحرف ت، من أكون؟', 
      answer: 'تلفاز',
      hint: 'أعرض الأفلام والبرامج'
    },
    { 
      riddle: 'أنا وسيلة نقل معلقة في الهواء، أبدأ بحرف ت، من أكون؟', 
      answer: 'تلفريك',
      hint: 'أحمل الناس بين الجبال'
    },
    { 
      riddle: 'أنا فاكهة حلوة المذاق، أكون طازجة أو مجففة، أبدأ بحرف ت، من أكون؟', 
      answer: 'تين',
      hint: 'أنا مليئة بالبذور الصغيرة'
    }
  ],
  'ث': [
    { 
      riddle: 'أنا حيوان ذكي، لوني أحمر، أبدأ بحرف ث، من أكون؟', 
      answer: 'ثعلب',
      hint: 'لدي ذيل طويل كثيف'
    },
    { 
      riddle: 'أنا فاكهة صغيرة حلوة، أبدأ بحرف ث، من أكون؟', 
      answer: 'ثمر',
      hint: 'أنا من الفواكه المجففة'
    },
    { 
      riddle: 'أنا قطعة من الملابس، أبدأ بحرف ث، من أكون؟', 
      answer: 'ثوب',
      hint: 'أنا لباس تقليدي'
    },
    { 
      riddle: 'أنا مكان للجنود، أبدأ بحرف ث، من أكون؟', 
      answer: 'ثكنة',
      hint: 'مكان إقامة العسكريين'
    },
    { 
      riddle: 'أنا نبات ذو رائحة قوية، أستخدم في الطبخ، أبدأ بحرف ث، من أكون؟', 
      answer: 'ثوم',
      hint: 'أنا من التوابل المشهورة'
    }
  ],
  'ج': [
    { 
      riddle: 'أنا حيوان صحراوي كبير، أبدأ بحرف ج، من أكون؟', 
      answer: 'جمل',
      hint: 'لدي سنام على ظهري'
    },
    { 
      riddle: 'أنا فاكهة استوائية، لوني أخضر من الخارج وأحمر من الداخل، أبدأ بحرف ج، من أكون؟', 
      answer: 'جوافة',
      hint: 'أنا مليئة بالبذور الصغيرة'
    },
    { 
      riddle: 'أنا جهاز صغير، أستخدم للاتصال، أبدأ بحرف ج، من أكون؟', 
      answer: 'جوال',
      hint: 'أحملني في جيبي'
    },
    { 
      riddle: 'أنا مكان جميل في السماء، أبدأ بحرف ج، من أكون؟', 
      answer: 'جنة',
      hint: 'مكان فيه كل شيء جميل'
    },
    { 
      riddle: 'أنا خضار برتقالي اللون، أبدأ بحرف ج، من أكون؟', 
      answer: 'جزر',
      hint: 'أنا مفيد للنظر'
    }
  ],
  'ح': [
    { 
      riddle: 'أنا حيوان سريع، أركض في السباقات، أبدأ بحرف ح، من أكون؟', 
      answer: 'حصان',
      hint: 'لدي شعر طويل على رقبتي'
    },
    { 
      riddle: 'أنا طعام حلو، يحبني الأطفال، أبدأ بحرف ح، من أكون؟', 
      answer: 'حلوى',
      hint: 'أنا مصنوعة من السكر'
    },
    { 
      riddle: 'أنا جهاز ذكي، أستخدم في العمل والدراسة، أبدأ بحرف ح، من أكون؟', 
      answer: 'حاسوب',
      hint: 'أعرض المعلومات على شاشة'
    },
    { 
      riddle: 'أنا مكان جميل مليء بالزهور والأشجار، أبدأ بحرف ح، من أكون؟', 
      answer: 'حديقة',
      hint: 'مكان للتنزه واللعب'
    },
    { 
      riddle: 'أنا نبات عطري، أستخدم في الطبخ، أبدأ بحرف ح، من أكون؟', 
      answer: 'حبق',
      hint: 'أنا من الأعشاب العطرية'
    }
  ],
  'خ': [
    { 
      riddle: 'أنا حيوان أليف، أعطي الصوف، أبدأ بحرف خ، من أكون؟', 
      answer: 'خروف',
      hint: 'أنا من الحيوانات الأليفة'
    },
    { 
      riddle: 'أنا فاكهة صيفية، لوني وردي، أبدأ بحرف خ، من أكون؟', 
      answer: 'خوخ',
      hint: 'أنا فاكهة حلوة المذاق'
    },
    { 
      riddle: 'أنا قطعة أثاث، أحفظ الملابس، أبدأ بحرف خ، من أكون؟', 
      answer: 'خزانة',
      hint: 'أنا في غرفة النوم'
    },
    { 
      riddle: 'أنا بيت متنقل، أبدأ بحرف خ، من أكون؟', 
      answer: 'خيمة',
      hint: 'أستخدم في التخييم'
    },
    { 
      riddle: 'أنا خضار أخضر، أبدأ بحرف خ، من أكون؟', 
      answer: 'خيار',
      hint: 'أنا من الخضروات الطازجة'
    }
  ],
  'د': [
    { 
      riddle: 'أنا طائر، أبدأ بحرف د، من أكون؟', 
      answer: 'ديك',
      hint: 'أنا أستيقظ الناس في الصباح'
    },
    { 
      riddle: 'أنا فاكهة صيفية، لوني وردي، أبدأ بحرف د، من أكون؟', 
      answer: 'دراق',
      hint: 'أنا فاكهة حلوة المذاق'
    },
    { 
      riddle: 'أنا قطعة أثاث، أحفظ الملابس، أبدأ بحرف د، من أكون؟', 
      answer: 'دولاب',
      hint: 'أنا في غرفة النوم'
    },
    { 
      riddle: 'أنا بيت، أبدأ بحرف د، من أكون؟', 
      answer: 'دار',
      hint: 'مكان يعيش فيه الناس'
    },
    { 
      riddle: 'أنا طعام حلو، أبدأ بحرف د، من أكون؟', 
      answer: 'دبس',
      hint: 'أنا مصنوع من التمر'
    }
  ],
  'ذ': [
    { 
      riddle: 'أنا حيوان بري، أبدأ بحرف ذ، من أكون؟', 
      answer: 'ذئب',
      hint: 'أنا من الحيوانات المفترسة'
    },
    { 
      riddle: 'أنا نبات، أبدأ بحرف ذ، من أكون؟', 
      answer: 'ذرة',
      hint: 'أنا من المحاصيل الزراعية'
    },
    { 
      riddle: 'أنا معدن ثمين، أبدأ بحرف ذ، من أكون؟', 
      answer: 'ذهب',
      hint: 'أنا من المعادن النفيسة'
    },
    { 
      riddle: 'أنا مكان مرتفع، أبدأ بحرف ذ، من أكون؟', 
      answer: 'ذروة',
      hint: 'أنا أعلى نقطة في الجبل'
    },
    { 
      riddle: 'أنا نبات، أبدأ بحرف ذ، من أكون؟', 
      answer: 'ذرة',
      hint: 'أنا من المحاصيل الزراعية'
    }
  ],
  'ر': [
    { 
      riddle: 'أنا حيوان قطبي، أبدأ بحرف ر، من أكون؟', 
      answer: 'رنة',
      hint: 'لدي قرون كبيرة'
    },
    { 
      riddle: 'أنا فاكهة حمراء، أبدأ بحرف ر، من أكون؟', 
      answer: 'رمان',
      hint: 'أنا مليئة بالحبات الحمراء'
    },
    { 
      riddle: 'أنا جهاز، أبدأ بحرف ر، من أكون؟', 
      answer: 'راديو',
      hint: 'أذيع الأغاني والأخبار'
    },
    { 
      riddle: 'أنا مكان للأطفال، أبدأ بحرف ر، من أكون؟', 
      answer: 'روضة',
      hint: 'مكان يتعلم فيه الأطفال'
    },
    { 
      riddle: 'أنا فاكهة، أبدأ بحرف ر، من أكون؟', 
      answer: 'رمان',
      hint: 'أنا مليئة بالحبات الحمراء'
    }
  ],
  'ز': [
    { 
      riddle: 'أنا حيوان طويل، أبدأ بحرف ز، من أكون؟', 
      answer: 'زرافة',
      hint: 'لدي رقبة طويلة جدًا'
    },
    { 
      riddle: 'أنا فاكهة صغيرة، أبدأ بحرف ز، من أكون؟', 
      answer: 'زيتون',
      hint: 'أستخدم في صنع الزيت'
    },
    { 
      riddle: 'أنا مادة شفافة، أبدأ بحرف ز، من أكون؟', 
      answer: 'زجاج',
      hint: 'أستخدم في صنع النوافذ'
    },
    { 
      riddle: 'أنا طريق ضيق، أبدأ بحرف ز، من أكون؟', 
      answer: 'زقاق',
      hint: 'أنا طريق صغير بين البيوت'
    },
    { 
      riddle: 'أنا نبات عطري، أبدأ بحرف ز، من أكون؟', 
      answer: 'زعتر',
      hint: 'أنا من الأعشاب العطرية'
    }
  ],
  'س': [
    { 
      riddle: 'أنا حيوان صغير، أبدأ بحرف س، من أكون؟', 
      answer: 'سنجاب',
      hint: 'أخزن الطعام في خدي'
    },
    { 
      riddle: 'أنا فاكهة صفراء، أبدأ بحرف س، من أكون؟', 
      answer: 'سفرجل',
      hint: 'أنا فاكهة شتوية'
    },
    { 
      riddle: 'أنا وسيلة نقل، أبدأ بحرف س، من أكون؟', 
      answer: 'سيارة',
      hint: 'أحمل الناس من مكان لآخر'
    },
    { 
      riddle: 'أنا مكان للبيع والشراء، أبدأ بحرف س، من أكون؟', 
      answer: 'سوق',
      hint: 'مكان يشتري فيه الناس احتياجاتهم'
    },
    { 
      riddle: 'أنا مادة حلوة، أبدأ بحرف س، من أكون؟', 
      answer: 'سكر',
      hint: 'أستخدم في تحلية الطعام'
    }
  ],
  'ش': [
    { 
      riddle: 'أنا حيوان صغير، أبدأ بحرف ش، من أكون؟', 
      answer: 'شبل',
      hint: 'أنا ابن الأسد'
    },
    { 
      riddle: 'أنا فاكهة صيفية، أبدأ بحرف ش، من أكون؟', 
      answer: 'شمام',
      hint: 'أنا فاكهة حلوة المذاق'
    },
    { 
      riddle: 'أنا أداة للحماية من الشمس، أبدأ بحرف ش، من أكون؟', 
      answer: 'شمسية',
      hint: 'أستخدم في الأيام المشمسة'
    },
    { 
      riddle: 'أنا مكان بجانب البحر، أبدأ بحرف ش، من أكون؟', 
      answer: 'شاطئ',
      hint: 'مكان للسباحة واللعب'
    },
    { 
      riddle: 'أنا مشروب ساخن، أبدأ بحرف ش، من أكون؟', 
      answer: 'شاي',
      hint: 'أشرب في الصباح والمساء'
    }
  ],
  'ص': [
    { 
      riddle: 'أنا طائر جارح، أبدأ بحرف ص، من أكون؟', 
      answer: 'صقر',
      hint: 'أنا من الطيور المفترسة'
    },
    { 
      riddle: 'أنا نبات شائك، أبدأ بحرف ص، من أكون؟', 
      answer: 'صبار',
      hint: 'أعيش في الصحراء'
    },
    { 
      riddle: 'أنا وعاء، أبدأ بحرف ص، من أكون؟', 
      answer: 'صندوق',
      hint: 'أستخدم لتخزين الأشياء'
    },
    { 
      riddle: 'أنا مكان جاف، أبدأ بحرف ص، من أكون؟', 
      answer: 'صحراء',
      hint: 'مكان فيه رمال كثيرة'
    },
    { 
      riddle: 'أنا نبات، أبدأ بحرف ص، من أكون؟', 
      answer: 'صبار',
      hint: 'أعيش في الصحراء'
    }
  ],
  'ض': [
    { 
      riddle: 'أنا حيوان برمائي، أبدأ بحرف ض، من أكون؟', 
      answer: 'ضفدع',
      hint: 'أقفز وأسبح'
    },
    { 
      riddle: 'أنا جزء من الفم، أبدأ بحرف ض، من أكون؟', 
      answer: 'ضرس',
      hint: 'أستخدم في مضغ الطعام'
    },
    { 
      riddle: 'أنا أداة، أبدأ بحرف ض، من أكون؟', 
      answer: 'ضرس',
      hint: 'أستخدم في مضغ الطعام'
    },
    { 
      riddle: 'أنا منطقة سكنية، أبدأ بحرف ض، من أكون؟', 
      answer: 'ضاحية',
      hint: 'أنا منطقة خارج المدينة'
    },
    { 
      riddle: 'أنا جزء من الفم، أبدأ بحرف ض، من أكون؟', 
      answer: 'ضرس',
      hint: 'أستخدم في مضغ الطعام'
    }
  ],
  'ط': [
    { 
      riddle: 'أنا طائر جميل، أبدأ بحرف ط، من أكون؟', 
      answer: 'طاووس',
      hint: 'لدي ذيل ملون جميل'
    },
    { 
      riddle: 'أنا خضار حمراء، أبدأ بحرف ط، من أكون؟', 
      answer: 'طماطم',
      hint: 'أستخدم في السلطة'
    },
    { 
      riddle: 'أنا قطعة أثاث، أبدأ بحرف ط، من أكون؟', 
      answer: 'طاولة',
      hint: 'أضع عليها الطعام'
    },
    { 
      riddle: 'أنا مسار، أبدأ بحرف ط، من أكون؟', 
      answer: 'طريق',
      hint: 'أسير عليه السيارات'
    },
    { 
      riddle: 'أنا خضار، أبدأ بحرف ط، من أكون؟', 
      answer: 'طماطم',
      hint: 'أستخدم في السلطة'
    }
  ],
  'ظ': [
    { 
      riddle: 'أنا حيوان سريع، أبدأ بحرف ظ، من أكون؟', 
      answer: 'ظبي',
      hint: 'لدي قرون جميلة'
    },
    { 
      riddle: 'أنا ظل، أبدأ بحرف ظ، من أكون؟', 
      answer: 'ظل',
      hint: 'أظهر عندما تكون الشمس ساطعة'
    },
    { 
      riddle: 'أنا ظل، أبدأ بحرف ظ، من أكون؟', 
      answer: 'ظل',
      hint: 'أظهر عندما تكون الشمس ساطعة'
    },
    { 
      riddle: 'أنا ظل، أبدأ بحرف ظ، من أكون؟', 
      answer: 'ظل',
      hint: 'أظهر عندما تكون الشمس ساطعة'
    },
    { 
      riddle: 'أنا ظل، أبدأ بحرف ظ، من أكون؟', 
      answer: 'ظل',
      hint: 'أظهر عندما تكون الشمس ساطعة'
    }
  ],
  'ع': [
    { 
      riddle: 'أنا طائر صغير، أبدأ بحرف ع، من أكون؟', 
      answer: 'عصفور',
      hint: 'أغرد في الصباح'
    },
    { 
      riddle: 'أنا فاكهة صغيرة، أبدأ بحرف ع، من أكون؟', 
      answer: 'عنب',
      hint: 'أنا من الفواكه الصيفية'
    },
    { 
      riddle: 'أنا جزء من السيارة، أبدأ بحرف ع، من أكون؟', 
      answer: 'عجلة',
      hint: 'أدور لأجعل السيارة تتحرك'
    },
    { 
      riddle: 'أنا مبنى كبير، أبدأ بحرف ع، من أكون؟', 
      answer: 'عمارة',
      hint: 'مكان يعيش فيه الناس'
    },
    { 
      riddle: 'أنا نبات أخضر، أبدأ بحرف ع، من أكون؟', 
      answer: 'عشب',
      hint: 'أنا من النباتات الخضراء'
    }
  ],
  'غ': [
    { 
      riddle: 'أنا حيوان جميل، أبدأ بحرف غ، من أكون؟', 
      answer: 'غزال',
      hint: 'لدي قرون جميلة'
    },
    { 
      riddle: 'أنا نبات عطري، أبدأ بحرف غ، من أكون؟', 
      answer: 'غار',
      hint: 'أستخدم في الطبخ'
    },
    { 
      riddle: 'أنا جزء من البيت، أبدأ بحرف غ، من أكون؟', 
      answer: 'غرفة',
      hint: 'مكان للنوم'
    },
    { 
      riddle: 'أنا مكان مليء بالأشجار، أبدأ بحرف غ، من أكون؟', 
      answer: 'غابة',
      hint: 'مكان يعيش فيه الحيوانات'
    },
    { 
      riddle: 'أنا نبات، أبدأ بحرف غ، من أكون؟', 
      answer: 'غار',
      hint: 'أستخدم في الطبخ'
    }
  ],
  'ف': [
    { 
      riddle: 'أنا حيوان كبير، أبدأ بحرف ف، من أكون؟', 
      answer: 'فيل',
      hint: 'لدي خرطوم طويل'
    },
    { 
      riddle: 'أنا فاكهة حمراء، أبدأ بحرف ف، من أكون؟', 
      answer: 'فريز',
      hint: 'أنا من الفواكه الصيفية'
    },
    { 
      riddle: 'أنا كوب صغير، أبدأ بحرف ف، من أكون؟', 
      answer: 'فنجان',
      hint: 'أشرب فيه القهوة'
    },
    { 
      riddle: 'أنا مكان للإقامة، أبدأ بحرف ف، من أكون؟', 
      answer: 'فندق',
      hint: 'مكان يقيم فيه المسافرون'
    },
    { 
      riddle: 'أنا خضار، أبدأ بحرف ف، من أكون؟', 
      answer: 'فلفل',
      hint: 'أنا من الخضروات الحارة'
    }
  ],
  'ق': [
    { 
      riddle: 'أنا حيوان ذكي، أبدأ بحرف ق، من أكون؟', 
      answer: 'قرد',
      hint: 'أنا من الحيوانات الذكية'
    },
    { 
      riddle: 'أنا طعام حلو، أبدأ بحرف ق، من أكون؟', 
      answer: 'قشطة',
      hint: 'أنا من منتجات الحليب'
    },
    { 
      riddle: 'أنا أداة للكتابة، أبدأ بحرف ق، من أكون؟', 
      answer: 'قلم',
      hint: 'أستخدم في الكتابة'
    },
    { 
      riddle: 'أنا مبنى كبير، أبدأ بحرف ق، من أكون؟', 
      answer: 'قصر',
      hint: 'مكان يعيش فيه الملوك'
    },
    { 
      riddle: 'أنا نبات عطري، أبدأ بحرف ق، من أكون؟', 
      answer: 'قرفة',
      hint: 'أستخدم في الطبخ'
    }
  ],
  'ك': [
    { 
      riddle: 'أنا حيوان أليف، أبدأ بحرف ك، من أكون؟', 
      answer: 'كلب',
      hint: 'أنا صديق الإنسان'
    },
    { 
      riddle: 'أنا فاكهة حمراء، أبدأ بحرف ك، من أكون؟', 
      answer: 'كرز',
      hint: 'أنا من الفواكه الصيفية'
    },
    { 
      riddle: 'أنا شيء للقراءة، أبدأ بحرف ك، من أكون؟', 
      answer: 'كتاب',
      hint: 'أقرأ فيه القصص'
    },
    { 
      riddle: 'أنا مكان للعبادة، أبدأ بحرف ك، من أكون؟', 
      answer: 'كنيسة',
      hint: 'مكان للصلاة'
    },
    { 
      riddle: 'أنا نبات، أبدأ بحرف ك، من أكون؟', 
      answer: 'كركديه',
      hint: 'أستخدم في صنع المشروبات'
    }
  ],
  'ل': [
    { 
      riddle: 'أنا حيوان مفترس، أبدأ بحرف ل، من أكون؟', 
      answer: 'لبؤة',
      hint: 'أنا ملكة الغابة'
    },
    { 
      riddle: 'أنا فاكهة حامضة، أبدأ بحرف ل، من أكون؟', 
      answer: 'ليمون',
      hint: 'أستخدم في الطبخ'
    },
    { 
      riddle: 'أنا مصدر للضوء، أبدأ بحرف ل، من أكون؟', 
      answer: 'لمبة',
      hint: 'أضيء الغرفة'
    },
    { 
      riddle: 'أنا مكان في الفندق، أبدأ بحرف ل، من أكون؟', 
      answer: 'لوبي',
      hint: 'مكان استقبال الضيوف'
    },
    { 
      riddle: 'أنا فاكهة، أبدأ بحرف ل، من أكون؟', 
      answer: 'ليمون',
      hint: 'أستخدم في الطبخ'
    }
  ],
  'م': [
    { 
      riddle: 'أنا حيوان أليف، أبدأ بحرف م، من أكون؟', 
      answer: 'ماعز',
      hint: 'أعطي الحليب'
    },
    { 
      riddle: 'أنا فاكهة صفراء، أبدأ بحرف م، من أكون؟', 
      answer: 'موز',
      hint: 'أنا من الفواكه الاستوائية'
    },
    { 
      riddle: 'أنا جهاز للتهوية، أبدأ بحرف م، من أكون؟', 
      answer: 'مروحة',
      hint: 'أجلب الهواء البارد'
    },
    { 
      riddle: 'أنا مكان للتعليم، أبدأ بحرف م، من أكون؟', 
      answer: 'مدرسة',
      hint: 'مكان يتعلم فيه الأطفال'
    },
    { 
      riddle: 'أنا فاكهة، أبدأ بحرف م، من أكون؟', 
      answer: 'موز',
      hint: 'أنا من الفواكه الاستوائية'
    }
  ],
  'ن': [
    { 
      riddle: 'أنا حيوان مفترس، أبدأ بحرف ن، من أكون؟', 
      answer: 'نمر',
      hint: 'لدي خطوط سوداء'
    },
    { 
      riddle: 'أنا فاكهة برتقالية، أبدأ بحرف ن، من أكون؟', 
      answer: 'نارنج',
      hint: 'أنا من الفواكه الحمضية'
    },
    { 
      riddle: 'أنا فتحة في الجدار، أبدأ بحرف ن، من أكون؟', 
      answer: 'نافذة',
      hint: 'أدخل منها الضوء'
    },
    { 
      riddle: 'أنا مجرى مائي، أبدأ بحرف ن، من أكون؟', 
      answer: 'نهر',
      hint: 'أجري في الأرض'
    },
    { 
      riddle: 'أنا نبات عطري، أبدأ بحرف ن، من أكون؟', 
      answer: 'نعناع',
      hint: 'أستخدم في صنع الشاي'
    }
  ],
  'ه': [
    { 
      riddle: 'أنا طائر جميل، أبدأ بحرف ه، من أكون؟', 
      answer: 'هدهد',
      hint: 'لدي عرف جميل على رأسي'
    },
    { 
      riddle: 'أنا نبات، أبدأ بحرف ه، من أكون؟', 
      answer: 'هندباء',
      hint: 'أنا من النباتات البرية'
    },
    { 
      riddle: 'أنا جهاز للاتصال، أبدأ بحرف ه، من أكون؟', 
      answer: 'هاتف',
      hint: 'أتحدث مع الآخرين'
    },
    { 
      riddle: 'أنا مكان مرتفع، أبدأ بحرف ه، من أكون؟', 
      answer: 'هضبة',
      hint: 'أنا منطقة مرتفعة'
    },
    { 
      riddle: 'أنا نبات، أبدأ بحرف ه، من أكون؟', 
      answer: 'هندباء',
      hint: 'أنا من النباتات البرية'
    }
  ],
  'و': [
    { 
      riddle: 'أنا حيوان زاحف، أبدأ بحرف و، من أكون؟', 
      answer: 'ورل',
      hint: 'أنا من الزواحف الكبيرة'
    },
    { 
      riddle: 'أنا زهرة جميلة، أبدأ بحرف و، من أكون؟', 
      answer: 'ورد',
      hint: 'أنا من الزهور الجميلة'
    },
    { 
      riddle: 'أنا شيء للكتابة، أبدأ بحرف و، من أكون؟', 
      answer: 'ورقة',
      hint: 'أكتب عليها'
    },
    { 
      riddle: 'أنا مكان منخفض، أبدأ بحرف و، من أكون؟', 
      answer: 'وادي',
      hint: 'أنا منطقة بين الجبال'
    },
    { 
      riddle: 'أنا زهرة، أبدأ بحرف و، من أكون؟', 
      answer: 'ورد',
      hint: 'أنا من الزهور الجميلة'
    }
  ],
  'ي': [
    { 
      riddle: 'أنا حيوان، أبدأ بحرف ي، من أكون؟', 
      answer: 'يعقوب',
      hint: 'أنا من الحيوانات البرية'
    },
    { 
      riddle: 'أنا فاكهة برتقالية، أبدأ بحرف ي، من أكون؟', 
      answer: 'يوسفي',
      hint: 'أنا من الفواكه الحمضية'
    },
    { 
      riddle: 'أنا جزء من الجسم، أبدأ بحرف ي، من أكون؟', 
      answer: 'يد',
      hint: 'أستخدمها للإمساك'
    },
    { 
      riddle: 'أنا قارب فاخر، أبدأ بحرف ي، من أكون؟', 
      answer: 'يخت',
      hint: 'أنا قارب للترفيه'
    },
    { 
      riddle: 'أنا زهرة عطرية، أبدأ بحرف ي، من أكون؟', 
      answer: 'ياسمين',
      hint: 'أنا من الزهور العطرية'
    }
  ]
};

export default riddles;